import React from 'react';

const Footer = () => (
  <div className="bg-white border-t">
    <div className="mx-auto px-4">
      <div className="md:flex justify-between items-center text-sm">
        <div className="md:flex md:flex-row-reverse items-center py-4">
          <div className="text-gray text-center md:mr-4">© 2022 Stocksfolio</div>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
